import React from "react";

import Icon, { IIcon } from "./Icon";
import Container from "@/src/components/atoms/Container/Container";
import ScrollContainer from "react-indiana-drag-scroll";
import SwipeMessage from "@/src/components/organisms/CompareChart/Swipe";

export type ICircleImageCarousel = {
    title: string;
    slides: IIcon[];
    iconFullSize?: boolean;
};

const CircleImageCarousel = (props: ICircleImageCarousel) => {
    return (
        <div className="IconCarousel-wrapper bg-accent-secondary-ada pb-12">
            <Container>
                <div className="IconCarousel-heading flex justify-center">
                    <h2 className="rounded-b-3xl bg-accent-secondary-background py-5 px-8 text-center text-sm font-bold">{props.title}</h2>
                </div>
            </Container>
            <SwipeMessage bgColorClass="text-text-contrast mt-4 md:mx-10 lg:mx-20" title={"Swipe"} />
            <ScrollContainer className="scroll-container flex cursor-pointer flex-nowrap" hideScrollbars={false}>
                <div className="mt-12 mb-4 flex items-center">
                    {props.slides.map((slide, index) => (
                        <Icon key={slide.url} icon={slide} carouselClassName={`carousel-item cursor-pointer number-slide${index + 1}`} iconFullSize={props.iconFullSize} />
                    ))}
                </div>
            </ScrollContainer>
        </div>
    );
};

export default CircleImageCarousel;
